/**
 * rp-users refuses every request of a user in the shared `fleet_onboarding_temp` group with
 * `403 ERR_ACCOUNT_SETUP_PENDING`. For login this is terminal: no fallback read, no session.
 */

/** Backend error code in the response body. */
export const ACCOUNT_SETUP_PENDING_CODE = 'ERR_ACCOUNT_SETUP_PENDING';

/** Code of the error the login helpers throw after signing the user out. */
export const ACCOUNT_SETUP_PENDING_AUTH_CODE = 'auth/account-setup-pending';

export const ACCOUNT_SETUP_PENDING_MESSAGE =
  'Your account is still being set up. Please contact ryd support.';

interface ErrorShape {
  code?: unknown;
  response?: { status?: number; data?: unknown };
}

/** True for the backend's 403 refusal or for the error the login helpers rethrow. */
export function isAccountSetupPendingError(error: ErrorShape | null | undefined): boolean {
  if (error?.code === ACCOUNT_SETUP_PENDING_AUTH_CODE) return true;
  if (error?.response?.status !== 403) return false;
  const data = error.response.data;
  if (typeof data !== 'object' || data === null) return false;
  return (data as { code?: unknown }).code === ACCOUNT_SETUP_PENDING_CODE;
}

export function accountSetupPendingError(): { code: string; message: string } {
  return { code: ACCOUNT_SETUP_PENDING_AUTH_CODE, message: ACCOUNT_SETUP_PENDING_MESSAGE };
}
